
import { Options, prop, Vue } from "vue-class-component";
import { ProductCardItem } from "@/domain/entities/BookingV4";
import ToggleV2 from "@/app/ui/components/toggle-v2/index.vue";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import ProductCard from "./product-card.vue";
import OverlayPanel from "primevue/overlaypanel";
import { SttAdjustmentRule } from "@/domain/entities/ShipmentBooking";
import { ConfigValidationForm } from "@/domain/entities/CreateBookingV3";

class Props {
  modelValue = prop<string | null>({ default: null });
  products = prop<ProductCardItem[]>({ required: true, type: Array });
  showAgentDiscountToggle = prop<boolean>({ required: true, type: Boolean });
  agentDiscountRevealed = prop<boolean>({ required: true, type: Boolean });
  agentDiscountToggleEnabled = prop<boolean>({ required: true, type: Boolean });
  loading = prop<boolean>({ default: false, type: Boolean });
  isError = prop<boolean>({ default: false, type: Boolean });
  currencyPrefix = prop<string>({ required: true, type: String, default: "Rp" });
  isClient = prop<boolean>({ required: true, type: Boolean, default: false });
  hideDiscount = prop<boolean>({ default: false, type: Boolean });
  // Adjust v4 per-field rules (GENESIS-20182) — optional, default EDITABLE
  configProductType = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configTariff = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
}

let productSelectionUid = 0;

@Options({
  name: "ProductCardListV4",
  emits: ["update:modelValue", "update:agentDiscountRevealed", "retry"],
  components: {
    ToggleV2,
    Skeleton,
    ProductCard,
    OverlayPanel
  }
})
class ProductCardListV4 extends Vue.with(Props) {
  declare $refs: {
    openTooltip: OverlayPanel
  }

  groupId = 0;

  created() {
    this.groupId = ++productSelectionUid;
  }

  get radioGroupName(): string {
    return `product-selection-${this.groupId}`;
  }

  get isNoRecommendation() {
    return !this.products.filter(p => p.isRecommended).length;
  }

  get disabledProductType(): boolean {
    return this.configProductType.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get hideTariff(): boolean {
    return this.configTariff.rule.includes(ConfigValidationForm.NON_SHOW);
  }

  get tooltipStyle() {
    return {
      fontFamily: "Montserrat",
      backgroundColor: "#4D4D4D",
      color: "#FFFFFF",
      fontSize: "12px",
      marginTop: "16px",
    };
  }

  onToggleAgentDiscount(value: boolean) {
    this.$emit("update:agentDiscountRevealed", value);
  }

  onSelectProduct(productType: string) {
    this.$emit("update:modelValue", productType);
  }

  onOpenTooltip(event: any) {
    this.$refs.openTooltip.toggle(event);
  }
}

export default ProductCardListV4;
